import axios, { AxiosError } from "axios"
import { Environment } from "./envirmoent"

export interface UserObject {
    readonly firstName: string,
    readonly lastName: string,
    readonly dueTimestamp: number,
    readonly documentID: string,
    readonly mobileNumber: string,
    readonly downpaymentCount: string,
    readonly isSmsSent: boolean,
    readonly smsID: string | null
}

export type UserByYearAndMonth = { [key: string]: { [key: string]: UserObject[] } }

export class Result<V, E> {
    readonly _v?: V
    readonly _e?: E

    static success<V, E>(v: V) {
        return new Result<V, E>({ v })
    }

    static error<V, E>(e: E) {
        return new Result<V, E>({ e: e })
    }

    constructor({ v, e }: { v?: V, e?: E }) {
        this._e = e
        this._v = v
    }

    public get isSuccess(): boolean {
        if (this._v != undefined && this._e == undefined) {
            return true
        } else {
            return false
        }
    }

    public get value(): V | undefined {
        return this._v
    }

    public get error(): E | undefined {
        return this._e
    }
}
export interface AddUserRequestProps {
    readonly firstName: string,
    readonly lastName: string,
    readonly fromDate: number,
    readonly documentID: string,
    readonly mobileNumber: string,
    readonly downpaymentCount: string,
    readonly carNumber: string
}

class UserService {
    readonly token: string
    readonly enpoint = `${Environment.environment.baseUrl}entry`

    constructor(token: string) {
        this.token = token
    }

    addEntry = async (data: AddUserRequestProps): Promise<Result<boolean, string>> => {
        try {
            const response = await axios.post(this.enpoint, data, {
                headers: {
                    "x-access-token": this.token
                }
            })

            return Result.success<boolean, string>(true)
        } catch (error) {
            if (axios.isAxiosError(error)) {
                return Result.error<boolean, string>(error.response?.data?.message || "Възникна грешка.")
            }

            return Result.error<boolean, string>("Документът не е записан.")
        }
    }

    getUsersByYearAndMonth = async (): Promise<UserByYearAndMonth> => {
        const response = await axios.get(this.enpoint)

        return {}
    }

    updateMobileNumber = async (userID: string, mobileNumber: string): Promise<boolean> => {
        try {
            const response = await axios.patch(this.enpoint, {
                userID,
                mobileNumber
            }, {
                headers: {
                    "x-access-token": this.token
                }
            })

            return true
        } catch (e) {
            return false
        }
    }
}

export default UserService